var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownDoubleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4629 9.0375L14.4024 7.977L12.5004 9.879V0H11.0004V9.879L9.09839 7.977L8.03789 9.0375L11.7504 12.75L15.4629 9.0375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46289 9.0375L6.40239 7.977L4.50039 9.879L4.50039 0H3.00039L3.00039 9.879L1.09839 7.977L0.0378909 9.0375L3.75039 12.75L7.46289 9.0375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDoubleIcon);
export default __webpack_public_path__ + "static/media/arrow-down-double-icon.ea01d21b676cc9d210abccd76fdc55ee.svg";
export { ForwardRef as ReactComponent };